import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { toJS } from '../../helpers/ImmutableToJS';
import * as a from './../../../libs/actions';

import { Button } from '../../ui/button';
import { Popup } from '../../ui/popup';

// styles
import css from './company.sss';


class BanView extends React.Component {

    handleCompanyBlock = () => {
        this.props.send(a.EVENT_BESIDA_SEND_BAN_LIST);
    }

    handleBackButton = (ev) => {
        ev.preventDefault();
        this.props.send(a.EVENT_COMPANY_BACK_TAB);
    }

    render() {
        return (
            <Popup
                dataQa='client_ban_block'
                dataCancelQa='cancel_ban_btn'
                onClose={this.handleBackButton}
            >
                <div className={css.banText}>
                    {t`Вы не сможете получать сообщения от этого продавца`}
                </div>
                <Button
                    dataQa='confirm_ban_btn'
                    onClick={this.handleCompanyBlock}
                >
                    {t`Заблокировать`}
                </Button>
            </Popup>
        );
    }
}

export const Ban = connect()(toJS(BanView));
